import { log } from "~features/seated-reservation/helpers/stateLogger";
import { dontUnselectSeatsPrompt } from "~features/seated-reservation/helpers/userPrompt";
import {
  getAvailableCategoriesForChart,
  getZoneKeys,
} from "~features/seated-reservation/helpers/zoneFilters";
import { getState, setState } from "../index";

export const onSidebarBack = async () => {
  log("onSidebarBack", undefined);

  const state = getState();

  if (dontUnselectSeatsPrompt(state.seats)) {
    return;
  }

  void state.chart.clearSelection();
  void state.chart.resetView();

  switch (state.sidebarIndex) {
    case 2: {
      return setState({
        seats: [],
        sidebarIndex: 1,
        currentZone: undefined,
      });
    }
    case 3: {
      const hasSections = state.currentZone.sections?.length > 0;

      return setState({
        seats: [],
        currentSection: undefined,
        // set sidebar index to the zone level if there are no sections.
        // This covers GeneralAdmission zones
        sidebarIndex: hasSections ? 2 : 1,
        currentZone: hasSections ? state.currentZone : undefined,
        // reset selection type so clicking on a new zone/section initiates auto select
        selectionType: "none",
      });
    }
    default:
      return;
  }
};
